import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";



import personal from "../../Assets/Projects/personal.jpeg";
import web3 from "../../Assets/Projects/web3.jpg";

import garage from "../../Assets/Projects/garage.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={web3}
              isBlog={false}
              title="Web3 Page"
              description="A simple React + Ethers.js project that allows users to connect their MetaMask wallet and submit anonymous feedback. Feedbacks are stored locally and tied to wallet addresses."
              ghLink="https://github.com/Shankar3804/Simple-Web3-"
              demoLink="https://simple-web3-rust.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={garage}
              
              title="Garage Management System"
              description="A comprehensive desktop application designed to streamline daily operations of automobile garages. The system allows for efficient management of customer and vehicle records, service logs, and billing processes. Built using VB.NET and MySQL, it features a user-friendly interface and role-based access control to support both administrators and staff in maintaining organized workflows."
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={personal}
              isBlog={false}
              title="Personal Finance Management"
              description="A desktop application built using VB.NET and MySQL to help users effectively manage their personal finances. The system allows users to log income and expenses, categorize transactions, and monitor financial trends through summary reports and visual charts. Designed with an intuitive interface and a focus on user-friendly financial planning, it simplifies budgeting and promotes better money management habits."
                            
            />
          </Col>

          

          </Row>
      </Container>
    </Container>
  );
}

export default Projects;
